export const inactividadopt1 = {
    data: {
        message: "Inactividad OTP propietario",
        leadId: "00Qdq000001hQ9xEAE",
        encryptedQuote: "1DM4tXxam7XGkjKRvN8RNrQ%2BnyvGBpe%2BPVCGmVS17fGXzJZR55yb0RLyjBo1dhW6"
    },
    error: false
}